<template lang="pug">
.v-input-wrapper
  label.v-input__label(:class="{ 'v-input__label--invalidd': invalid }") {{ label }}
  .v-input(:class="[classes, { 'v-input--has-value': hasValue, 'v-input--focused': isFocused }]")
    template(v-if="!isDatePicker")
      input.v-input__field(
        v-focus="focus"
        type="text"
        :value="value"
        :disabled="disabled"
        :autocomplete="autocomplete"
        :pattern="pattern"
        @input="onInput"
        @focus="onFocus"
        @blur="onBlur")
    template(v-else)
      slot(
        name="date-picker"
        v-bind="{ isDatePicker }")
    .v-input__bar(:class="focusBar")
    .v-input__icon.v-input__icon--right(
      :class="focusIcon")
      slot(name="icon-right")
  .v-input__hint-wrapper
    .v-input__hint(v-if="hint") {{ hint }}
</template>

<script>
export default {
  name: 'VInput',

  props: {
    label: String,
    value: [String, Number],
    disabled: Boolean,
    autocomplete: {
      type: String,
      default: 'off'
    },
    isDatePicker: {
      type: Boolean,
      default: false
    },
    pattern: {
      type: String,
      default: null
    },
    hint: {
      type: String,
      default: null
    },
    invalid: {
      type: Boolean,
      default: false
    },
    isVisiblePopover: Boolean,
    focus: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      isFocused: false
    }
  },

  computed: {
    classes () {
      return {
        'v-input--invalid': this.invalid
      }
    },
    focusBar () {
      return {
        'v-input__bar--focus': this.isDatePicker && this.isVisiblePopover
      }
    },
    focusIcon () {
      return {
        'v-input__icon--focus': this.isVisiblePopover
      }
    },
    hasValue () {
      return this.value !== null && this.value !== '' && this.value !== undefined
    }
  },

  methods: {
    onInput (e) {
      this.$emit('input', e.target.value)
    },

    onFocus () {
      this.isFocused = true
    },

    onBlur () {
      this.isFocused = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/sass/abstracts/_variables.scss';

.v-input-wrapper {
  padding-top: 0;
  margin-bottom: 0.2rem;
}

.v-input__label {
  display: block;
  color: $color-gray;
  font-size: 1.3rem;
  margin-bottom: .5rem;
  pointer-events: none;
  line-height: 1.3rem;

  &--invalid {
    color: $color-red !important;
  }
}

.v-input {
  position: relative;

  &__field {
    width: 100%;
    font-size: 1.5rem;
    padding: 1rem;
    height: 4rem;
    display: block;
    border: .2rem solid transparent;
    border-radius: 1rem;
    background: #EEEEEE;
    transition: background-color 0.2s ease, border-color 0.2s ease;

    &:focus {
      outline: none;
    }

    &:disabled {
      opacity: .5;
      cursor: not-allowed;
    }

    &:focus ~ .v-input__bar:before,
    &:focus ~ .v-input__bar:after {
      width: 50%;
    }

    &:focus ~ .v-input__icon {
      color: $color-black;
    }
  }

  &__hint-wrapper {
    min-height: 1.5rem;
  }

  &__hint {
    color: $color-red;
    font-size: 1.2rem;
    font-weight: 300;
    position: relative;
    bottom: -2px;
  }

  &--invalid {
    .v-input__field {
      background: #fff5f5;
    }
  }

  &--has-value {
    .v-input__field {
      background-color: #F4F4F4;
    }
  }

  &--focused {
    .v-input__field {
      background-color: #DDF2E3;
    }
  }

  &__icon {
    position: absolute;
    top: 0;
    height: 100%;
    width: 3rem;
    font-size: 2rem;
    color: $color-gray;
    display: flex;
    align-items: center;
    justify-content: center;

    &--focus {
      color: $color-black;
    }

    &--right {
      right: 0;
    }
  }
}
</style>